/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { TournamentAccessControlEnumType } from './TournamentAccessControlEnum'
import { TournamentDifficultyEnumType } from './TournamentDifficultyEnum'
import { TournamentKindEnumType } from './TournamentKindEnum'
import { RootStoreType } from './index'

/**
 * TournamentBase
 * auto generated base class for the model TournamentModel.
 */
export const TournamentModelBase = ModelBase.named('Tournament')
  .props({
    __typename: types.optional(types.literal('Tournament'), 'Tournament'),
    accessControl: types.union(types.undefined, types.null, TournamentAccessControlEnumType),
    actionTime: types.union(types.undefined, types.null, types.number),
    blindTimer: types.union(types.undefined, types.null, types.number),
    color: types.union(types.undefined, types.string),
    difficulty: types.union(types.undefined, types.null, TournamentDifficultyEnumType),
    endTime: types.union(types.undefined, types.frozen()),
    name: types.union(types.undefined, types.string),
    scheduledStartDayOfWeekUTC: types.union(types.undefined, types.null, types.number),
    scheduledStartHoursUTC: types.union(types.undefined, types.null, types.number),
    scheduledStartMinutesUTC: types.union(types.undefined, types.null, types.number),
    startTime: types.union(types.undefined, types.frozen()),
    startingChips: types.union(types.undefined, types.null, types.number),
    tournamentKind: types.union(types.undefined, types.null, TournamentKindEnumType)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TournamentModelSelector extends QueryBuilder {
  get accessControl() {
    return this.__attr('accessControl')
  }
  get actionTime() {
    return this.__attr('actionTime')
  }
  get blindTimer() {
    return this.__attr('blindTimer')
  }
  get color() {
    return this.__attr('color')
  }
  get difficulty() {
    return this.__attr('difficulty')
  }
  get endTime() {
    return this.__attr('endTime')
  }
  get name() {
    return this.__attr('name')
  }
  get scheduledStartDayOfWeekUTC() {
    return this.__attr('scheduledStartDayOfWeekUTC')
  }
  get scheduledStartHoursUTC() {
    return this.__attr('scheduledStartHoursUTC')
  }
  get scheduledStartMinutesUTC() {
    return this.__attr('scheduledStartMinutesUTC')
  }
  get startTime() {
    return this.__attr('startTime')
  }
  get startingChips() {
    return this.__attr('startingChips')
  }
  get tournamentKind() {
    return this.__attr('tournamentKind')
  }
}
export function selectFromTournament() {
  return new TournamentModelSelector()
}

export const tournamentModelPrimitives =
  selectFromTournament().accessControl.actionTime.blindTimer.color.difficulty.endTime.name.scheduledStartDayOfWeekUTC
    .scheduledStartHoursUTC.scheduledStartMinutesUTC.startTime.startingChips.tournamentKind
